function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  id: "circle",
  fill: "#FFFFFF",
  cx: 256.252,
  cy: 255.986,
  r: 253.093
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "blue-piece",
  fill: "#3E5BA9",
  d: "M455.398,412.197c33.792-43.021,53.946-97.262,53.946-156.211  c0-139.779-113.313-253.093-253.093-253.093c-30.406,0-59.558,5.367-86.566,15.197C272.435,71.989,408.349,247.839,455.398,412.197z  "
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "left-red-piece",
  fill: "#9F1D20",
  d: "M220.003,164.337c-39.481-42.533-83.695-76.312-130.523-98.715  C36.573,112.011,3.159,180.092,3.159,255.986c0,63.814,23.626,122.104,62.597,166.623  C100.111,319.392,164.697,219.907,220.003,164.337z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  id: "bottom-red-piece",
  fill: "#9F1D20",
  d: "M266.638,221.727c-54.792,59.051-109.392,162.422-129.152,257.794  c35.419,18.857,75.84,29.559,118.766,29.559c44.132,0,85.618-11.306,121.74-31.163C357.171,381.712,317.868,293.604,266.638,221.727  z"
});

const SvgRacket = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "circle_pieces",
    x: "0px",
    y: "0px",
    height: "10em",
    viewBox: "0 0 511.875 511.824",
    enableBackground: "new 0 0 511.875 511.824",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRacket, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Racket.5e6da43b.svg";
export { ForwardRef as ReactComponent };